<template>
  <div class="reading-question-view">
    <!--    <div class="question-desc-view">{{questioninfo.desc}}</div>-->
    <div class="question-reading-info-view">
      <div class="question-top">
        <div class="sing-play-btn" @click="playsing(questionData.content_audio)" v-if="questionData.reading_time == 0">
          <div>听力材料</div>
        </div>
      </div>
      <div class="reading-question-contents-view" v-if="questioninfo.content != ''">
        <div id="parent" class="reading-contentinfo-view" v-html="showcontent()"></div>
      </div>
      <div class="reading-question-options-content-view"
        v-if="questioninfo.sub_questions && questioninfo.sub_questions.length > 0">
        <div class="question-reading-options-view">
          <template v-for="(question, index) in questioninfo.sub_questions">
            <div class="reading-question-content">
              <div v-html="question.content"></div>
            </div>
            <div class="reading-question-options-view" v-if="question.option_type == 1">
              <template v-for="(optioninfos, oindex) in question.optioninfos">
                <div :id="'option' + index + oindex" class="reading-question-optionitem"
                  :class="[getIsselect(optioninfos.isselect) ? 'select-reading-item' : '', optioninfos.showicon && optioninfos.answerright ? 'answerright-reading-item' : '', optioninfos.showicon && optioninfos.answerwrong ? 'answerwrong-reading-item' : '']"
                  @click="chosethis(index, oindex)">
                  <div v-html="optionchart[oindex] + '、' + optioninfos.option" v-if="question.show_type == 1"></div>
                  <div v-html="optioninfos.option" v-if="question.show_type == 2"></div>

                </div>
              </template>
            </div>
            <div class="reading-question-options-view" v-if="question.option_type == 2">
              <template v-for="optioninfos, oindex in question.optioninfos">
                <div :id="'option' + index + oindex" class="reading-question-optionitem1"
                  :class="[getIsselect(optioninfos.isselect) ? 'select-reading-item' : '']"
                  @click="chosethis(index, oindex)">
                  <div class="qusetion-quesetion-optionitem-img"
                    :style="'background:url(' + baseurl + optioninfos.option + ');background-size:100% 100%'"></div>

                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
    <audio ref="readingmusic" controls="controls" style="display: none" preload="auto" @ended="playend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
import apiUtil from "@/api/apiUtils"
import Apis from "@/api"
import Vue from 'vue';

export default {
  name: "readingquestion",
  data() {
    return {
      questioninfo: {},
      optionindex: 0,
      answerindex: 0,
      isCanClick: false,
      showanswertype: false,
      baseurl: apiUtil.getBaseUrl(),
      showdesc: true,
      audiourl: "",
      localindex: 0,
      totalindex: 0,
      descplay: false,
      optionchart: this.getOptionIndex()
    }
  },
  props: {
    questionData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isShowHead: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    "questionData": function () {
      this.initData()
    }
  },
  mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.initData()
    })
  },
  methods: {
    showdescbtn() {
      if (this.showdesc == false) {
        this.showdesc = true;
        this.$refs.readingmusic.pause()
      }
    },
    initData() {
      this.questioninfo = this.questionData
      this.questioninfo.sub_questions.forEach(qitem => {
        if (!qitem.optioninfos) {
          var optionsinfos = []
          var options = qitem.options.split("|")
          options.forEach(oitem => {
            var optioninfo = {}
            optioninfo.option = oitem;
            optioninfo.isselect = false;
            optionsinfos.push(optioninfo);
          })
          qitem.optioninfos = this.randomSort(optionsinfos)
        }
      })
    },
    paraseData(questiondata) {
      var that = this;
      var parent1 = document.getElementById('parent1');
      if (parent1) {
        parent1.innerHTML = "";
      }
      var thisCount = 0;
      thisCount = this.substring(questiondata.content, "||")
      for (var i = 0; i < thisCount; i++) {
        var idinfo = "answer" + i;
        if (i == 0) {
          var html = "<span id='" + idinfo + "' class='answer-t-view fillanswer' style='background:#F2F2F2;border-bottom:2px solid #8c939d;'  >" + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + "</span>"
        } else {
          var html = "<span id='" + idinfo + "' class='answer-t-view fillanswer' style='border-bottom:2px solid #8c939d;'  >" + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + "</span>"
        }
        questiondata.content = questiondata.content.replace("||", html)
      }
      var thiscontent = questiondata.content.replace(/\\n/g, "</br>")
      thiscontent = thiscontent.split("</br>");
      var strcontent = ""
      for (var j = 0; j < thiscontent.length; j++) {
        var contentinfo = thiscontent[j];
        console.log(contentinfo)
        if (contentinfo.indexOf("<img>") > -1) {
          var contentitems = contentinfo.split("<img>")
          for (var k = 0; k < contentitems.length; k++) {
            if (contentitems[k].indexOf(".jpeg") > -1 || contentitems[k].indexOf(".png") > -1 || contentitems[k].indexOf(".jpg") > -1) {
              var imgurl = apiUtil.getBaseUrl() + contentitems[k]
              strcontent += "<img style='width: 180px;height: 180px' src='" + imgurl + "'/>";
            } else {
              strcontent += contentitems[k]
            }
          }
          strcontent += "</br>"
        } else {
          strcontent += contentinfo + "</br>"
        }
      }
      questiondata.content = "<div>" + strcontent + "</div>"
      setTimeout(() => {
        var MyComponent1 = Vue.extend({
          template: questiondata.content,
          data() {
            return {
              allcount: thisCount
            }
          },
          methods: {}
        });
        that.component = new MyComponent1().$mount();
        var parent = document.getElementById('parent1');
        parent.innerHTML = "";
        parent.appendChild(that.component.$el);
      }, 100)
      this.$nextTick(() => {
        that.questioninfo = questioninfo;
        console.log(that.questioninfo)
      })
    },
    chosethis(qindex, oindex) {
      let _this = this;
      var optioninfos = _this.questioninfo.sub_questions[qindex].optioninfos
      _this.questioninfo.sub_questions[qindex].isanswer = true;
      _this.checkallclick();
      optioninfos.forEach((oitem, opindex) => {
        if (opindex == oindex) {
          oitem.isselect = true
        } else {
          oitem.isselect = false
        }
        _this.$set(optioninfos, opindex, oitem)
      })

      this.checkanswer()
      this.$forceUpdate()
    },
    getIsselect(select) {
      return select
    },
    showcontent() {
      if (this.questioninfo.content)
        return this.questioninfo.content.replace(/12pt/g, "24px");
    },
    playsing(msg) {
      var that = this;
      that.$emit("playsing", this.baseurl + msg)
    },
    checkanswer() {
      this.questioninfo.sub_questions.forEach((item, index) => {
        if (item.isanswer) {
          item.optioninfos.forEach((oitem, oindex) => {
            if (oitem.isselect) {
              item.useroption = oitem.option
            }
          })
        }

      })
      this.questioninfo.isfinish = true;
      this.$emit("questionfinish", this.questioninfo)
      this.$forceUpdate()

    },
    checkallclick() {
      var flag = true;
      this.questioninfo.sub_questions.forEach(item => {
        if (!item.isanswer || item.isanswer == undefined) {
          flag = false;
        }
      })
      return flag;
    },
    playdesc(event) {
      let that = this;
      var params = {
        'text': that.questioninfo.desc,
        'activity': ""
      }
      apiUtil.httpServer(Apis.getAudioData, params).then(res => {
        if (res.code == 200) {
          var audiourl = apiUtil.getBaseUrl() + res.data.amazon_url;
          this.$refs.readingmusic.src = audiourl;
          if (that.$refs.readingmusic.paused) {
            that.$refs.readingmusic.play()
            that.descplay = true;
          }
        }
      })
      event.stopPropagation();
    },
    deschide() {
      this.showdesc = false;
      this.$refs.readingmusic.pause()
    },
    prev() {
      this.$emit("goToPrev")
      this.$refs.readingmusic.pause()
    },
    next() {
      this.$emit("goToNext")
      this.$refs.readingmusic.pause()
    },
    playend() {
      this.descplay = false;
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .reading-question-view {
    width 100%;
    height 100%;
  }

  .question-reading-info-view {
    display flex;
    flex-direction column;
    width 100%;
    height 75%;
  }
  .sing-play-btn {
    margin 10px auto;
    width 240px;
    height 60px;
    display flex;
    background url("../../assets/img/question-device-bg.png")
    background-size 100% 100%;
    align-items center;
    color #5D79FA;
    font-size 30px;

    & > div {
      margin-left 80px;
    }
  }

  .reading-question-contents-view {
    display flex;
    flex:1
    overflow-y auto;
  }

  .reading-question-options-content-view {
    display flex;
    flex:1
    overflow-y auto;
  }

  .reading-contentinfo-view {
    height 500px;
    text-align left;
    font-size 18px !important;
    font-weight normal;
    overflow-y auto;
    margin 15px 15px 10px 15px;
    padding 10px 20px;
  }

  .question-reading-options-view {
    width 100%;
    display flex;
    flex-direction column;
    position relative;
  }

  .reading-question-content {
    width 90%;
    display flex;
    flex-wrap wrap;
    margin 10px auto;
    padding 10px;
    font-size 36px;
    word-break: break-word;
    text-align left;
  }

  .reading-question-optionitem {
    width: 90%;
    margin 12px auto;
    padding 15px 0;
    font-size 24px;
    background: rgba(255, 255, 255, 1);
    border: 3px solid rgba(0, 0, 0, 1);
    border-radius: 12px;
    position relative;
  }

  .reading-question-optionitem1 {
    width: 180px;
    height 180px;
    margin 12px auto;
    padding 15px 0;
    font-size 24px;
    background: rgba(255, 255, 255, 1);
    border: 3px solid rgba(0, 0, 0, 1);
    border-radius: 12px;
    position relative;
  }

  .qusetion-quesetion-optionitem-img {
    width 180px;
    height 180px;
    border-radius: 12px;
  }

  .select-reading-item {
    background: #AEBCFC;
    border: 3px solid #5D79FA;
  }

  .answerright-reading-item {
    background: #fff;
    border: 3px solid #92C761;
  }

  .answerwrong-reading-item {
    background: #fff;
    border: 3px solid #F45578;
  }

  .reading-bottom-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;
  }

  .reading-finish-btn {
    width 50%;
    height 72px;
    font-size 36px;
    position absolute;
    left 25%;
    bottom 30px;
    border-radius 36px;
    background #5777FF;
    color #fff;
  }

  .disable-btn {
    pointer-events: none;
    opacity 0.5
  }


  .reading-bottom-answertype {
    width 100%;
    height 90px;
    display flex;
    justify-content center;
    align-items center;
    font-size 30px;
  }

  .reading-bottom-answertype img {
    width 68px;
    height 68px;
    margin-right 24px;
  }

  .answerright-text {
    color #F5C55D;
  }

  .answerwrong-text {
    color #F45578;
  }

  .reading-question-options-content-view::-webkit-scrollbar {
    display block !important;
    width: 10px !important; /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px !important;
  }

  .reading-question-options-content-view::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 10px !important;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
    background: #5d79fa !important;
  }

  .reading-question-options-content-view::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
    border-radius: 10px !important;
    background: #EDEDED !important;
  }

  .reading-contentinfo-view::-webkit-scrollbar {
    display block !important;
    width: 10px !important; /*高宽分别对应横竖滚动条的尺寸*/
    height: 2px !important;
  }

  .reading-contentinfo-view::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 10px !important;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
    background: #5d79fa !important;
  }

  .reading-contentinfo-view::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
    border-radius: 10px !important;
    background: #EDEDED !important;
  }

  @media screen and (max-width: 1600px) {
    .question-reading-info-view {
      display: flex;
      width: 100%;
      height: 75%;
    }

    .reading-bottom-view {
      height 50px;
    }

    .reading-finish-btn {
      height 48px;
      font-size 24px;
      bottom 5px;
      border-radius 36px;
    }

    .reading-contentinfo-view {
      height 380px;
      text-align left;
      font-weight normal;
      overflow-y auto;
      margin 15px 15px 10px 15px;
      padding 10px 20px;
      z-index 10;
    }

    .reading-bottom-answertype {
      height 50px;
      display flex;
      justify-content center;
      align-items center;
      font-size 24px;
    }

    .reading-question-content {
      font-size 24px;
    }

    .reading-bottom-answertype img {
      width 40px;
      height 40px;
      margin-right 24px;
    }

    .reading-question-optionitem {
      margin 10px auto;
      padding 10px 0;
      font-size 20px;
    }

    .reading-question-optionitem1 {
      width: 140px;
      height 140px;
      margin 10px auto;
      padding 10px 0;
      font-size 20px;
    }

    .qusetion-quesetion-optionitem-img {
      width: 140px;
      height 140px;
    }
  }

  @media screen and (max-width: 1366px) and (max-height: 657px) {
    .question-reading-info-view {
      display: flex;
      width: 100%;
      height: 70%;
      position: relative;
    }

    .reading-bottom-view {
      height 50px;
    }

    .reading-finish-btn {
      height 48px;
      font-size 24px;
      bottom 5px;
      border-radius 36px;
    }

    .reading-contentinfo-view {
      height 300px;
      text-align left;
      font-weight normal;
      overflow-y auto;
      margin 15px 15px 10px 15px;
      padding 10px 20px;
      z-index 10;
    }

    .reading-bottom-answertype {
      height 50px;
      display flex;
      justify-content center;
      align-items center;
      font-size 24px;
    }

    .reading-question-content {
      font-size 24px;
    }

    .reading-bottom-answertype img {
      width 40px;
      height 40px;
      margin-right 24px;
    }

    .reading-question-optionitem {
      margin 10px auto;
      padding 10px 0;
      font-size 20px;
    }

    .reading-question-optionitem1 {
      width: 140px;
      height 140px;
      margin 10px auto;
      padding 10px 0;
      font-size 20px;
    }

    .qusetion-quesetion-optionitem-img {
      width: 140px;
      height 140px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/readingquestion.vue